import { render, staticRenderFns } from "./LostShipments.vue?vue&type=template&id=0ff96b77&scoped=true"
import script from "./LostShipments.vue?vue&type=script&lang=js"
export * from "./LostShipments.vue?vue&type=script&lang=js"
import style0 from "./LostShipments.vue?vue&type=style&index=0&id=0ff96b77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff96b77",
  null
  
)

export default component.exports